import { render, staticRenderFns } from "./Equipamiento.vue?vue&type=template&id=601988c9&scoped=true&"
import script from "./Equipamiento.vue?vue&type=script&lang=js&"
export * from "./Equipamiento.vue?vue&type=script&lang=js&"
import style0 from "./Equipamiento.vue?vue&type=style&index=0&id=601988c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601988c9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VMain})
